import { render, staticRenderFns } from "./InstallationFeatures.vue?vue&type=template&id=a18c41a2&scoped=true"
import script from "./InstallationFeatures.vue?vue&type=script&lang=js"
export * from "./InstallationFeatures.vue?vue&type=script&lang=js"
import style0 from "./InstallationFeatures.vue?vue&type=style&index=0&id=a18c41a2&prod&lang=scss"
import style1 from "./InstallationFeatures.vue?vue&type=style&index=1&id=a18c41a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18c41a2",
  null
  
)

export default component.exports